// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2tlag","cell":"ColumnAccessor_cell__n-HHu","firstCellAccent":"ColumnAccessor_firstCellAccent__171zB"};